import React from "react";
import { Box, Flex } from "theme-ui";
import ActionRequiredBanner from "./ActionRequiredBanner";
import ClientOverview from "./overview/ClientOverview";
import MyClientProjects from "./MyClientProjects";
import QuotesAwaitingResponse from "./QuotesAwaitingResponse";
import OutstandingDepositsWidget from "./OutstandingDepositsWidget";

/**
 * The client dashboard (DASHBOARD_REDESIGN_SPEC section 4).
 *
 * The overview goes ON TOP, and the existing working surfaces stay
 * BELOW it - unlike the internal dashboard, where the old widgets were
 * replaced. The difference is that these are not duplicates: the
 * client's projects list and quote list are how they actually do
 * things, and the overview answers "how are we doing" above them.
 *
 * `ClientKPICards` and the client `ActionItems` panel ARE duplicates of
 * the overview and came off. The banner stays for now: unlike the
 * internal one it is the client's only alert surface, and the read-only
 * decisions list does not replace it yet.
 */
const ClientDashboard: React.FC = () => {
  return (
    <Box>
      <ActionRequiredBanner dashboardType="client" />

      <ClientOverview section="metrics" />

      <Box sx={{ marginBottom: "24px" }}>
        <MyClientProjects />
      </Box>

      {/* Plans. Session 76: the component decides its own placement.
          A client WITH plans gets a status read, and that belongs with
          their work — it renders here. A client with NO plans gets a
          pitch, and a pitch belongs at the very bottom, after everything
          they actually came for. Each slot renders only its own case, so
          exactly one appears. */}
      <ClientOverview section="plans" placement="inline" />

      <OutstandingDepositsWidget />

      <Flex sx={{ gap: "16px", flexWrap: "wrap", alignItems: "stretch" }}>
        <QuotesAwaitingResponse />
      </Flex>

      <ClientOverview section="plans" placement="footer" />
    </Box>
  );
};

export default ClientDashboard;
